module.exports = __webpack_public_path__ + "static/header_bg-68e7c1313b93e759cd4aea768ad37ebe.webp";